import { render, staticRenderFns } from "./CommonTranslationTsResult.vue?vue&type=template&id=02abcc62&scoped=true"
import script from "./CommonTranslationTsResult.vue?vue&type=script&lang=js"
export * from "./CommonTranslationTsResult.vue?vue&type=script&lang=js"
import style0 from "./CommonTranslationTsResult.vue?vue&type=style&index=0&id=02abcc62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02abcc62",
  null
  
)

export default component.exports